import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { UploadKaroakeRequest } from './uploadkaroakerequest';

export class UploadKaroakeAPI extends SixdeeCRBTAPI<UploadKaroakeRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/upload-karoake
        return "upload-karoake";
    }

    getHttpHeaders():string
    {
       let baseHeaders = super.getHttpHeaders();
       let combinedHeaders : any;

       let uploadKaroakeHeader = {
            "content-type" : 'multipart/form-data'
       } as any; 

       combinedHeaders = Object.assign(uploadKaroakeHeader, baseHeaders);
       return combinedHeaders;
    }

    getRequestData()
    {
        let formaData = new FormData();
        formaData.append("clientTxnId", "24062020");
        formaData.append("serviceId", this.getRequest().getUploadKaroakeRequest().getServiceId());
        formaData.append("toneFile", this.getRequest().getUploadKaroakeRequest().getToneFile());
        formaData.append("toneName", this.getRequest().getUploadKaroakeRequest().getToneName());
        formaData.append("aPartyMsisdn", this.getRequest().getUploadKaroakeRequest().getAPartyMsisdn());
        formaData.append("isCopy", this.getRequest().getUploadKaroakeRequest().getIscopy().toString());
        formaData.append("channelId", this.getRequest().getUploadKaroakeRequest().getChannelId());
        formaData.append("language", this.getRequest().getUploadKaroakeRequest().getLanguage());
        formaData.append("priority", this.getRequest().getUploadKaroakeRequest().getPriority());

        return formaData;

        /* return "clientTxnId=23062020"+"&"+
               "serviceId=" + this.getRequest().getUploadKaroakeRequest().getServiceId() +"&"+
               "toneFile="+ this.getRequest().getUploadKaroakeRequest().getToneFile() +"&"+
               "toneName="+ this.getRequest().getUploadKaroakeRequest().getToneName()+"&"+
               "aPartyMsisdn=" + this.getRequest().getUploadKaroakeRequest().getAPartyMsisdn() +"&"+
               "isCopy=" + this.getRequest().getUploadKaroakeRequest().getIscopy() +"&"+
               "channelId="+ this.getRequest().getUploadKaroakeRequest().getChannelId()+"&"+
               "language="+ this.getRequest().getUploadKaroakeRequest().getLanguage()+"&"+
               "priority="+ this.getRequest().getUploadKaroakeRequest().getPriority(); */
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/karoake/uploadkaroake/uploadkaroakeapi.tsx